<template>
    <v-layout v-if="ready" justify-center>
        <v-responsive max-width="1024px" width="100%" height="100%" class="shop-product-view">
            <div v-if="!$route.params._product" class="headline text-start mt-8">상품 등록</div>
            <div v-else class="headline text-start mt-8">상품 상세</div>

            <v-tabs v-model="tab" background-color="content" class="mt-4">
                <v-tab key="basic">기본상품정보</v-tab>
                <v-tab-item key="basic" >
                    <product-basic-info v-model="product"></product-basic-info>
                </v-tab-item>
            </v-tabs>

            <v-row justify="center">
                <v-col md="auto" sm="auto">
                    <v-btn color="primary" @click="save">저장</v-btn>
                </v-col>
            </v-row>

        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

import ProductBasicInfo from "@/components/console/shop/products/product-basic-info.vue";

export default {
    components: {
        ProductBasicInfo
    },
    data() {
        return {
            ready: false,
            tab: "basic",

            ///////////////////////////////////////////////
            // 상품정보
            ///////////////////////////////////////////////
            product: {
                _category: null,
                sequence: 0,

                name: null,
                code: null,
                price: 0,
                companyPrice: 0,
                cost: 0,
                stock: 0,
                
                thumb: null,
                images: new Array(5),

                content: null,

                display: true,
                sale: true,
                best: false,
                newly: false,
                special: false,
                soldout: false,

                hashtags: [],

                meta: {
                    manufacturer: null,
                    origin: null
                },

                options: [],
                supplies: []
            },
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            try{
                if(this.$route.params._product || this.$route.query._product){
                    var { product } = await api.console.shop.products.getProduct({ _id: this.$route.params._product || this.$route.query._product });
                    this.product = product;
                }

                this.ready = true;
            }
            catch(error){
                console.error(error);
                if(error.response) alert(error.response.data.message);
            }
        },
        async save(){
            try{
                ////////////////////////////////////////////////////////////////
                // 1. 상품저장
                ////////////////////////////////////////////////////////////////
                var { product } = this.product._id ? await api.console.shop.products.putProduct(this.product) : await api.console.shop.products.postProduct(this.product);

                ////////////////////////////////////////////////////////////////
                // 2. 옵션저장
                ////////////////////////////////////////////////////////////////
                if(this.product.optionEnabled) this.product.optionEnabled = 0 < this.product.options.filter(option => !option.deleted).length;
                else {
                    do{
                        var option = this.product.options.find(option => !option.deleted);
                        if(!option) this.product.options.splice(this.product.options.indexOf(option), 1);
                        else option.deleted = true;
                    }while(option);
                }

                for(let option of this.product.options){
                    option._product = product._id;

                    if(option.deleted){
                        await api.console.shop.products.options.deleteOption(option);
                    }
                    else if(option._id){
                        await api.console.shop.products.options.putOption(option);
                    }
                    else if(!option._id){
                        await api.console.shop.products.options.postOption(option);
                    }
                }

                ////////////////////////////////////////////////////////////////
                // 3. 추가상품저장
                ////////////////////////////////////////////////////////////////
                if(this.product.supplyEnabled) this.product.supplyEnabled = 0 < this.product.supplies.filter(supply => !supply.deleted).length;
                else{
                    do{
                        var supply = this.product.supplies.find(supply => !supply.deleted);
                        if(!supply) this.product.supplies.splice(this.product.supplies.indexOf(supply), 1);
                        else supply.deleted = true;
                    }while(supply);
                }

                for(let supply of this.product.supplies){
                    supply._product = product._id;

                    if(supply.deleted){
                        await api.console.shop.products.supplies.deleteSupply(supply);
                    }
                    else if(supply._id){
                        await api.console.shop.products.supplies.putSupply(supply);
                    }
                    else if(!supply._id){
                        await api.console.shop.products.supplies.postSupply(supply);
                    }
                }

                ////////////////////////////////////////////////////////////////
                // 4. 썸네일 저장
                ////////////////////////////////////////////////////////////////
                if(this.product.thumb) await api.console.shop.products.postThumb(product._id, this.product.thumb);

                ////////////////////////////////////////////////////////////////
                // 5. 이미지 저장
                ////////////////////////////////////////////////////////////////
                for(var index in this.product.images){
                    if(this.product.images[index]) await api.console.shop.products.postImage(product._id, index, this.product.images[index]);
                }

                alert(this.product._id ? "수정되었습니다" : "저장되었습니다");

                this.$router.go(-1);
                
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
}
</script>
